{
    "Profile_Dwellings_Improvement.improvement": "FR: Improvement",
    "Profile_Dwellings_Improvement.improvementDetails": "FR: Improvement Details",
    "Profile_Dwellings_Improvement.description": "FR: Description",
    "Profile_Dwellings_Improvement.value": "FR: Value"
}
